import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Countertop, CountertopMaterial } from '../../models/cutting/public-api';

@Injectable()
export class CountertopSettingsStateService {
  userId = 0;

  private _material: BehaviorSubject<CountertopMaterial> = new BehaviorSubject<CountertopMaterial>(undefined);
  private _countertop: BehaviorSubject<Countertop> = new BehaviorSubject<Countertop>(undefined);

  get countertop$(): Observable<Countertop> {
    return this._countertop.asObservable();
  }

  get material$(): Observable<CountertopMaterial> {
    return this._material.asObservable();
  }

  updateCountertop(countertop: Countertop): void {
    this._countertop.next(countertop);
  }

  setMaterial(material: CountertopMaterial): void {
    this._material.next(material);

    if (this._countertop.value) {
      this._countertop.value.material = material;
      this.updateCountertop(this._countertop.value);
    }
  }
}
